export type Dict = {
  topbar: { sub: string; day: string };
  counter: { cases: string; deceased: string; countries: string };
  rail: { filters: string; strain: string; vector: string; country: string; nationality: string; hint: string };
  vector: { cruise: string; plane: string; none: string };
  caseType: { detected: string; deceased: string };
  detail: {
    casesLabel: string;
    deceasedLabel: string;
    strainLabel: string;
    occurredLabel: string;
    reportedLabel: string;
    sources: string;
    vectorPrefix: string;
    coordsLabel: string;
  };
  timeline: { play: string; pause: string };
  empty: { none: string; select: string };
  map: { fitAll: string };
  route: { openIncident: string };
  ticker: { label: string; empty: string };
  legend: {
    btn: string; title: string;
    persons: string; vehicles: string; routes: string; country: string; vectors?: string;
    ill: string; suspected: string; deceased: string; cleared: string; cluster: string;
    shipIcon: string; planeIcon: string; medevacIcon: string;
    ship: string; plane: string; medevac: string;
    pinStep: string; pinCap: string;
    countryNote: string;
  };
  lastSync: string;
};

export const en: Dict = {
  topbar: {
    sub: "Hantavirus Updates",
    day: "DAY",
  },
  counter: {
    cases: "TOTAL CASES",
    deceased: "DECEASED",
    countries: "COUNTRIES",
  },
  rail: {
    filters: "FILTERS",
    strain: "STRAIN",
    vector: "VECTOR",
    country: "COUNTRIES INVOLVED",
    nationality: "NATIONALITIES AFFECTED",
    hint: "Source: NOS.nl + global health authorities",
  },
  vector: {
    cruise: "Cruise ship",
    plane: "Plane",
    none: "Local transmission",
  },
  caseType: {
    detected: "Detected",
    deceased: "Deceased",
  },
  detail: {
    casesLabel: "Reported cases",
    deceasedLabel: "Deceased",
    strainLabel: "Strain",
    occurredLabel: "Occurred",
    reportedLabel: "Reported",
    sources: "Sources & references",
    vectorPrefix: "Spread vector:",
    coordsLabel: "Coordinates",
  },
  timeline: {
    play: "Play",
    pause: "Pause",
  },
  empty: {
    none: "No incidents on this date",
    select: "Click a marker to inspect an incident",
  },
  map: { fitAll: "FIT ALL" },
  route: { openIncident: "Open incident →" },
  ticker: { label: "DAILY BRIEF", empty: "No events recorded for this date." },
  legend: {
    btn: "LEGEND",
    title: "LEGEND",
    persons: "PATIENTS (HOSPITAL)",
    vehicles: "VESSELS & AIRCRAFT",
    routes: "ROUTES & WAYPOINTS",
    country: "COUNTRY HIGHLIGHT",
    ill: "Confirmed (lab-positive, ill)",
    suspected: "Suspected (under investigation)",
    deceased: "Deceased",
    cleared: "Cleared (tested negative)",
    cluster: "Cluster — tap to expand at higher zoom",
    shipIcon: "Cruise ship (Hondius)",
    planeIcon: "Passenger flight aircraft",
    medevacIcon: "Medical evacuation aircraft",
    ship: "Cruise ship route (cyan dashed)",
    plane: "Passenger flight (yellow dotted)",
    medevac: "Medical evacuation (grey dotted)",
    pinStep: "Daily waypoint — click for date + note",
    pinCap: "Departure / current head of journey",
    countryNote: "Tinted = country with active or confirmed case",
  },
  lastSync: "last sync",
};
